// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginComponent_loginContainer__18-Ob","welcomeMessage":"LoginComponent_welcomeMessage__EQNea"};